import React, { useEffect, useState } from "react";
import { Card, Col, Spinner, OverlayTrigger } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuildingColumns,
  faCamera,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import EG_Admin_Icon from "assets/icons/Subtraction.png";
import emailIcon from "assets/icons/email.png";
import End_User_Icon from "assets/icons/end-user.png";
import info from "assets/icons/info.png";
import EG_Consultant_Icon from "assets/icons/user-tie.png";
import Internal_Admin_Icon from "assets/icons/verified.png";
import {
  BRANCH_ADMIN,
  BRANCH_CONSULTANT,
  END_USER,
} from "common/constants/constants";
import { PRODUCTS, VDS_MANAGEMENT } from "common/constants/permissionKeys";
import Loader from "components/common/loader/Loader";
import NestedCheckbox from "components/common/nestedCheckbox/NestedCheckbox";
import { useBranchName } from "hooks/branchName/useBranchName";
import { formatPermissions } from "utils/Utils";
import { handleClaimsParentLevel } from "utils/Utils";
import { updateProfilePicture } from "services/UserAccountManagementServices";

import {
  getUserById,
  getUserOrganizationDetailById,
} from "services/UserManagementServices";
import { getUserPermissions } from "services/UserManagementServices";
import { updateUserClaims } from "services/UserManagementServices";
import { getBranchProducts } from "services/branchServices";
import { fetchUsersProfilePicture } from "services/UserManagementServices";

import "./branchUserDetail.scss";
import { CommonButton } from "components/common/button/Button";
import { setResendPasswordLink } from "services/UserAccountManagementServices";
import { useTranslation } from "react-i18next";
const BranchUserDetail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getBranchNameContext } = useBranchName();
  const [userDetails, setUserDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [permissionsList, setPermissionsList] = useState([]);
  const branchNameContext = getBranchNameContext();
  const [disable, setDisable] = useState(true);
  const [bankId, setBankId] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [organizationData, setOrganizationData] = useState(null);

  const [userProfilePicture, setUserProfilePicture] = useState({
    url: null,
    isFetching: false,
  });
  const {
    firstName = "-",
    lastName = "-",
    email = "",
    claims = [],
    role = {},
    branchInfo = {},
    emailConfirmed = false,
  } = userDetails;
  const rolesInfo = {
    End_User: {
      imgSrc: End_User_Icon,
      discription: t("end-user-description"),
      bgColor: "#4CE228",
      name: "#EU",
    },
    EG_Consultant: {
      imgSrc: EG_Consultant_Icon,
      discription: t("eg-consultant-description"),
      bgColor: "#A32C48",
      name: "#EC",
    },
    EG_Admin: {
      imgSrc: EG_Admin_Icon,
      discription: t("eg-admin-description"),
      bgColor: "#FF3B68",
      name: "#EA",
    },
    Internal_Admin: {
      imgSrc: Internal_Admin_Icon,
      notes: t("internal-admin-notes"),
      discription: t("internal-admin-description"),
      bgColor: "#3B61FF",
      name: "#IA",
    },
  };
  const currentRoleInfo =
    rolesInfo[userDetails?.role?.roleTranslatedValue.split(" ").join("_")] ||
    {};
  let { branchId: branchIdParam, userId: userIdParam } = useParams();
  useEffect(() => {
    getUserDetails();
    getUserCompanyDetails();
  }, [refresh]);
  const getUserCompanyDetails = async () => {
    let result = await getUserOrganizationDetailById(userIdParam);
    if (result) {
      setOrganizationData(result);
    }
  };
  const getActiveUserPermissions = (claims, permissions) => {
    for (let i = 0; i < permissions.length; i++) {
      const elementI = permissions[i];
      if (claims?.includes(elementI.claimKey)) {
        elementI.value = true;
      }
      // else if (!claims?.includes(elementI.claimKey)) {
      //   permissions.splice(permissions.indexOf(elementI), 1);
      // }

      if (elementI.hasOwnProperty("sub"))
        getActiveUserPermissions(claims, elementI.sub);
    }
  };
  const handleRefresh = () => setRefresh((pre) => !pre);
  const handleImageChange = async (file) => {
    let form_data = new FormData();
    const payLoad = {
      userId: userIdParam,
      profilePicture: file,
    };
    Object.keys(payLoad).forEach((key) =>
      form_data.append(`${key}`, payLoad[key])
    );

    let response = await updateProfilePicture(form_data);
    if (!response.success) {
      toast.error(t("err-put-profile"));
    } else handleRefresh();
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileName = file?.name;
      const extension = fileName?.split(".")?.pop()?.toLowerCase();
      const isSupported = ["jpg", "png", "jpeg"].includes(extension);
      if (isSupported) {
        handleImageChange(event.target.files[0]);
        event.target.value = "";
      } else {
        toast.error(t("err-img-format"));
      }
    }
  };
  const getUserDetails = async () => {
    try {
      const result = await getUserById(userIdParam);

      if (!result?.success) {
        handleErrorResponse(result, "err-get-user-data");
        return;
      }

      const userDetails = result?.payLoad;
      setUserDetails(userDetails);
      setBankId(userDetails?.branchInfo?.bankId);

      await loadUserProfilePicture();
      await processUserPermissions(userDetails);

      setIsLoading(false);
    } catch (error) {
      console.error("Error in getUserDetails:", error);
      toast.error(t("err-get-user-data"));
    }
  };

  const loadUserProfilePicture = async () => {
    try {
      if (userDetails?.profilePicture) {
        setUserProfilePicture({ ...userProfilePicture, isFetching: true });
        const result = await fetchUsersProfilePicture(userIdParam);

        if (result.status === 200)
          setUserProfilePicture({
            url: URL.createObjectURL(result.data),
            isFetching: false,
          });
      }
    } catch (error) {
      console.error("Error in loadUserProfilePicture:", error);
    }
  };

  const processUserPermissions = async (userDetails) => {
    try {
      const assignedProductToUser = userDetails?.applicationKeys;
      const userRoleName = userDetails?.role?.roleName;

      const resultPermissions = await getUserPermissions();

      if (!resultPermissions?.success) {
        handleErrorResponse(resultPermissions, "err-get-permission");
        return;
      }

      const branchProducts = await loadBranchProducts(userDetails);
      const rawPermissions = filterRawPermissions(
        resultPermissions.payLoad,
        assignedProductToUser,
        branchProducts,
        userRoleName
      );

      const formattedPermissions = formatPermissions(rawPermissions);
      const activeClaims = userDetails?.claims.map(
        (elementI) => elementI.claimKey
      );
      getActiveUserPermissions(activeClaims, formattedPermissions);
      setPermissionsList([...formattedPermissions]);
    } catch (error) {
      console.error("Error in processUserPermissions:", error);
    }
  };

  const loadBranchProducts = async (userDetails) => {
    const { branchId, bankId, bankGroupId } = userDetails?.branchInfo || {};
    const pathIds = { branchId, bankId, bankgroupsId: bankGroupId };
    const branchProductsResult = await getBranchProducts(pathIds);

    return branchProductsResult.success
      ? branchProductsResult.payLoad
          .filter((product) => product.assigned === "Active")
          .map((product) => product.productKey)
      : [];
  };

  const filterRawPermissions = (
    rawPermissions,
    assignedProductToUser,
    branchProducts,
    userRoleName
  ) => {
    let filteredPermissions = [...rawPermissions];

    if (["#EC", "#EU"].includes(userRoleName)) {
      filteredPermissions = filteredPermissions.filter(
        (item) =>
          item.applicationKey == null ||
          item.applicationKey === "#VdsManagement" ||
          (assignedProductToUser.length > 0
            ? assignedProductToUser.includes(item.applicationKey)
            : branchProducts.includes(item.applicationKey))
      );
    }

    return filteredPermissions.filter((item) => item.type === userRoleName);
  };

  // Add other helper functions as needed...

  const handleErrorResponse = (response, errorMessageKey) => {
    console.error(`Error in API response: ${response?.message}`);
    toast.error(t(errorMessageKey));
  };

  const handleChange = (event, item) => {
    let list = handleClaimsParentLevel(event, item, permissionsList);
    setPermissionsList([...list]);
    setDisable(false);
  };

  let totalClaims = [];
  const getAllActiveClaims = (list) => {
    list?.forEach((child) => {
      if (child.value) totalClaims.push(child.claimId);
      if (child.hasOwnProperty("sub")) getAllActiveClaims(child.sub);
    });
  };

  const handleSubmit = async () => {
    getAllActiveClaims(permissionsList);
    let obj = {
      claims: totalClaims,
    };
    setLoading(true);
    let result = await updateUserClaims(userIdParam, obj);
    if (result?.success) {
      setLoading(false);
      setDisable(false);
    } else {
      setLoading(false);
      setDisable(false);
      toast.error(t("err-put-claims"));
    }
  };
  const handleResendLink = async (id) => {
    setIsFetching(true);
    await setResendPasswordLink(id);
    setIsFetching(false);
  };
  const handleOpacity = (disable) => {
    return disable ? "opacity-50" : "";
  };
  const getProfilePicture = () => {
    return (
      (userProfilePicture.isFetching && (
        <Spinner animation="border" size="sm" />
      )) ||
      (userProfilePicture.url && (
        <img alt="not found" src={userProfilePicture.url} />
      )) || (
        <span>
          {`${(firstName && firstName[0]) || "-"}${
            (lastName && lastName[0]) || "-"
          }`}
        </span>
      )
    );
  };
  return (
    <>
      <Toaster />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="eg-user claims">
          <div className="custom-breadcrumbs mx-5 px-2">
            <span
              className="breadcrumbs-item "
              onClick={() => {
                navigate("/branches");
              }}
            >
              {t("branches")}
            </span>
            <span
              className="breadcrumbs-item "
              onClick={() => {
                navigate(`/branches/${branchIdParam}`, { state: bankId });
              }}
            >
              <p>{branchNameContext}</p>
            </span>
            <span className="breadcrumbs-item ">
              <p>
                {firstName + " "} {lastName}
              </p>
            </span>
          </div>
          <div className="d-flex flex-wrap">
            <Col lg={6} sm={12}>
              <div className="role">
                <h3>{t("role")}</h3>
                <img src={currentRoleInfo?.imgSrc} />
                <span className="ms-2">{t(currentRoleInfo?.name)}</span>
                <p className="paragraph">{currentRoleInfo?.discription}</p>
                {currentRoleInfo?.highlight && (
                  <p className="line-text">{currentRoleInfo?.highlight}</p>
                )}
                {currentRoleInfo?.notes && (
                  <Card className="info-card flex-row">
                    <img src={info} width={19} height={19} />
                    <p className="ms-2 mb-0">{currentRoleInfo?.notes}</p>
                  </Card>
                )}
                <h3 className="mt-4">{t("allowed-permission")}</h3>

                <NestedCheckbox
                  permissionsList={permissionsList}
                  handleChange={handleChange}
                />
                <button
                  className={`${handleOpacity(
                    disable
                  )} update-btn mb-5 mt-3 w-auto`}
                  onClick={handleSubmit}
                  disabled={disable}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      {t("update-claims")}
                    </>
                  ) : (
                    t("update-claims")
                  )}
                </button>
              </div>
            </Col>
            <Col lg={6} sm={12}>
              <div className="account">
                <h3>{t("account")}</h3>
                <Card className="acc-card flex-row flex-wrap">
                  <div
                    className="circle-icon col-md-2"
                    style={{
                      background: userProfilePicture.url
                        ? "transparent"
                        : "#4CE228",
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      fontSize: "18px",
                    }}
                  >
                    {getProfilePicture()}
                    <div className="overlay">
                      <FontAwesomeIcon
                        icon={faCamera}
                        size="2x"
                        color="white"
                      />
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={onImageChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-10">
                    <p className="ms-4 flex-grow-1">
                      {`${firstName || "--"} ${lastName || "--"}`}
                      <br />
                      <span className="pt-4  d-inline-block">
                        <img src={emailIcon} className="me-2" />
                        {email}
                      </span>
                      {userDetails?.role?.roleName === "#EU" &&
                      userDetails?.applicationKeys?.includes("#Gecco") ? (
                        <div className="konto-form">
                          <span
                            className="pt-4  d-inline-block"
                            style={{ width: "70%" }}
                          >
                            <label className="labels">{t("companyName")}</label>
                            <br></br>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="name-tooltip">
                                  {organizationData?.name}
                                </Tooltip>
                              }
                            >
                              <input
                                style={{
                                  width: "100%",
                                  backgroundColor: "white",
                                  padding: "5px",
                                  borderRadius: "5px",
                                }}
                                disabled={true}
                                value={organizationData?.name}
                              ></input>
                            </OverlayTrigger>
                          </span>

                          <span
                            style={{ marginLeft: "5%", width: "25%" }}
                            className="pt-4  d-inline-block"
                          >
                            <label className="labels">{t("street")}</label>
                            <br></br>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="name-tooltip">
                                  {organizationData?.city}
                                </Tooltip>
                              }
                            >
                              <input
                                style={{
                                  width: "100%",
                                  backgroundColor: "white",
                                  padding: "5px",
                                  borderRadius: "5px",
                                }}
                                disabled={true}
                                value={organizationData?.city}
                              ></input>
                            </OverlayTrigger>
                          </span>
                          <br />

                          <span
                            className="pt-4  d-inline-block"
                            style={{ width: "25%" }}
                          >
                            <label className="labels">{t("postalCode")}</label>
                            <br></br>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="name-tooltip">
                                  {organizationData?.postalCode}
                                </Tooltip>
                              }
                            >
                              <input
                                style={{
                                  width: "100%",
                                  backgroundColor: "white",
                                  padding: "5px",
                                  borderRadius: "5px",
                                }}
                                disabled={true}
                                value={organizationData?.postalCode}
                              ></input>
                            </OverlayTrigger>
                          </span>

                          <span
                            style={{ marginLeft: "5%", width: "70%" }}
                            className="pt-4  d-inline-block"
                          >
                            <label className="labels">{t("address")}</label>
                            <br></br>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="name-tooltip">
                                  {organizationData?.address1}
                                </Tooltip>
                              }
                            >
                              <input
                                style={{
                                  width: "100%",
                                  backgroundColor: "white",
                                  padding: "5px",
                                  borderRadius: "5px",
                                }}
                                disabled={true}
                                value={organizationData?.address1}
                              ></input>
                            </OverlayTrigger>
                          </span>
                          <br />
                        </div>
                      ) : null}
                      <br />

                      {!emailConfirmed && (
                        <CommonButton
                          title={
                            isFetching ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                                {t("resend-password")}
                              </>
                            ) : (
                              <p className="fw-2 m-0">{t("resend-password")}</p>
                            )
                          }
                          borderRadius="5px"
                          border="none"
                          padding="8px 15px"
                          margin="20px 0 0 0"
                          click={() => handleResendLink(userIdParam)}
                          disabled={isFetching}
                        />
                      )}
                    </p>
                  </div>
                  <br />
                </Card>
              </div>
            </Col>
          </div>
        </div>
      )}
    </>
  );
};

export default BranchUserDetail;
